import Account from "components/Objects/Account";
import AccountCustomizations from "components/Objects/AccountCustomizations";
import AccountIntegrations from "components/Objects/AccountIntegrations";
import AccountRegisterAuditing from "components/Objects/AccountRegisterAuditing";
import AddLayaway from 'components/Objects/AddLayaway'
import AddWorkOrder from 'components/Objects/AddWorkOrder'
import AddLayawayPayment from 'components/Objects/AddLayawayPayment'
import AddWorkOrderPayment from 'components/Objects/AddWorkOrderPayment'
import AltrupaySpinProcessor from "./AltrupaySpinProcessor";
import Billing from "components/Objects/Billing";
import Certificate from "components/Objects/Certificate";
import Checkout from "components/Objects/Checkout";
import Consignment from "components/Objects/Consignment"
import Customer from "components/Objects/Customer";
import Dashboard from "components/Objects/Dashboard";
import Inventory from "components/Objects/Inventory";
import Kiosk from "components/Objects/Kiosk";
import Layaway from "components/Objects/Layaway"
import WorkOrder from "components/Objects/WorkOrder"
import Location from "components/Objects/Location";
import Membership from "components/Objects/Membership";
import MembershipEnrollmentModal from "components/Objects/MembershipEnrollmentModal";
import Payment from "components/Objects/Payment"
import InvoicePayment from "components/Objects/InvoicePayment"
import Receipt from "components/Objects/Receipt";
import Service from "components/Objects/Service";
import Register from "components/Objects/Register";
import RegisterLedger from "components/Objects/RegisterLedger";
import RegisterLedgerCount from "components/Objects/RegisterLedgerCount";
import Sku from "components/Objects/Sku";
import SkuClass from "components/Objects/SkuClass";
import Subscription from "components/Objects/Subscription";
import TradeIn from "components/Objects/TradeIn";
import Transaction from "components/Objects/Transaction";
import TransactionRefund from "components/Objects/TransactionRefund";
import LayawayPaymentRefund from "components/Objects/LayawayPaymentRefund";
import User from "components/Objects/User";
import Refund from "components/Objects/Refund";

const Objects =  {
	Account: Account,
	AccountCustomizations: AccountCustomizations,
	AccountIntegrations: AccountIntegrations,
	AccountRegisterAuditing: AccountRegisterAuditing,
	AddLayaway:AddLayaway,
	AddWorkOrder:AddWorkOrder,
	AddLayawayPayment:AddLayawayPayment,
	AddWorkOrderPayment:AddWorkOrderPayment,
	AltrupaySpinProcessor:AltrupaySpinProcessor,
	Billing: Billing,
	Certificate: Certificate,
	Customer: Customer,
	Checkout: Checkout,
	Consignment: Consignment,
	Dashboard: Dashboard,
	Inventory: Inventory,
	Kiosk: Kiosk,
	Layaway: Layaway,
	WorkOrder: WorkOrder,
	Location: Location,
	Membership: Membership,
	MembershipEnrollmentModal: MembershipEnrollmentModal,
	Payment:Payment,
	InvoicePayment:InvoicePayment,
	Refund: Refund,
	Receipt: Receipt,
	Service: Service,
	Register: Register,
	RegisterLedger: RegisterLedger,
	RegisterLedgerCount: RegisterLedgerCount,
	Sku: Sku,
	SkuClass: SkuClass,
	Subscription: Subscription,
	TradeIn: TradeIn,
	Transaction: Transaction,
	TransactionRefund: TransactionRefund,
	LayawayPaymentRefund: LayawayPaymentRefund,
	User: User,

};

export default Objects;
